import React from 'react';
import { BackButton } from 'containers/SignUpContainerPage/SignUpPage/formConstants';
import SignInLogo from './assets/Sign-In.png';
import SignUpLogo from './assets/Sign-Up.png';
import WindCreekCasinosLogo from './assets/Logo-WC-white.png';
import './AuthHeader.css';

const HeaderLogo = ({ logoName }) => {
  let logo;
  switch (logoName) {
    case 'login':
      logo = SignInLogo;
      break;
    case 'signup':
      logo = SignUpLogo;
      break;
    default:
      logo = null;
  }
  return (
    <div className="logo-container">
      <img src={WindCreekCasinosLogo} alt="Wind Creek Casinos" />
      {logo && <img className="sub-logo" src={logo} alt={logoName} />}
    </div>
  );
};

const AuthHeader = ({ logoName, onBack }) => {
  return (
    <div className="auth-header">
      {onBack && <BackButton onClick={onBack} />}
      <HeaderLogo logoName={logoName} />
    </div>
  );
};

export default AuthHeader;
